


/********************************************************************************************************/
/************************************   GH TABLE DIRECTIVE    *******************************************/
/********************************************************************************************************/

/*  Render table in the field and in the application*/

/********************************************************************************************************/

angular.module('ghTableModule', [])

    /*============================================================================================================*/
    /*============================================  TABLE CONTROL  ===============================================*/
    /*============================================================================================================*/
    .directive('ghTable', ['$compile', '$location', '$filter', 'storage', 'ghWindowsService', 'PipeService', 'Message', 'filterItem', '$timeout', function($compile, $location, $filter, storage, ghWindowsService, PipeService, Message, filterItem, $timeout) {
      return {
            restrict: 'E',
            scope: {
                ghItemId: '@',
                ghAppId: '@',
                ghFieldData: '=', /* field model*/
                //ghFormData: '=',
                ghMode: '@', // Must be 'static' or 'dynamic. Default: 'dynamic'
    //DEPRICATED!!!!!! Set items in model!!!!!! by property 'replace_items'           replaceItems: '=?', // for import items
                //takeFilterFromModel: '=?', // for dropdown filtering instead of table filtering
                callback: '&?'

            },

            controller: [ '$scope', '$element', '$rootScope', async function($scope, $element, $rootScope) {

              $scope.appId =  $scope.ghFieldData && $scope.ghFieldData.data_model && $scope.ghFieldData.data_model.app_id || $scope.ghAppId;

              if(!$scope.appId || !$scope.ghFieldData) {
                return;
              }

              // ID default sort field
              // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! TEMPORARY !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
              if($scope.ghFieldData.data_model.table_settings.sort_table_field){
                angular.extend($scope.ghFieldData.data_model.table_settings, {
                  sort_table_by: {
                    field_id: angular.copy($scope.ghFieldData.data_model.table_settings.sort_table_field)
                  }
                });
              }

              if(!$scope.ghFieldData.data_model.table_settings.sort_table_by){
                angular.extend($scope.ghFieldData.data_model.table_settings, {
                  sort_table_by: {
                    field_id: ''
                  }
                });
              }
              // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

              $scope.fieldsToView = [];
              $scope.Math = Math;

              var address = {
                app_id: $scope.appId
              };

              var filters = {
                filters_list: $scope.ghFieldData.data_model.filters_list || [],
                search: $scope.ghFieldData.data_model.search
              };
              
              let filterUpdate = function(event, data) {
                filters.filters_list = gudhub.mergeFilters($scope.ghFieldData.data_model.filters_list, data);
                $scope.itemsList.applyFilter();
              }

              let searchUpdate = function(event, data) {
                filters.search = data;
                $scope.itemsList.applyFilter();
              }

              gudhub.on('filter', { app_id: $scope.ghFieldData.data_model.app_id, field_id: $scope.ghFieldData.field_id }, filterUpdate)
              gudhub.on('search', { app_id: $scope.ghFieldData.data_model.app_id, field_id: $scope.ghFieldData.field_id }, searchUpdate)

              class Items {
                constructor(persistentItems) {
                  let self = this;
                  this.sortByField = {
                    id: $scope.ghFieldData.data_model.table_settings.sort_table_by.field_id || null,
                    descending: Boolean(+$scope.ghFieldData.data_model.table_settings.items_order)
                  };

                  if (persistentItems) {
                    this.items = persistentItems;
                    this.filtered = persistentItems;
                  } else {
                    this.items = [];
                    this.filtered = [];
                    
                    const loadItems = async () => {
                      const items = await gudhub.getItems(address.app_id);
                      self.replaceItems(items);
                      console.log("itemsPipe");
                      $scope.$digest();
                    }

                    loadItems();
                    
                    //-- Updating items
                    PipeService.on('gh_items_update', address, loadItems, $scope);

                    //-- Destroy PipeService
                    $scope.$on('$destroy', function() {
                      PipeService.destroy('gh_items_update',address, loadItems);
                      gudhub.destroy('filter', { app_id: $scope.ghFieldData.data_model.app_id, field_id: $scope.ghFieldData.field_id }, filterUpdate);
                      
                      //TODO this breaks picking slabs for QT module
                      //ActionService.cleanSelectedTableItems($scope.appId);
                    });	

                  }
                }

                replaceItems(items) {
                  this.items = items;
                  this.applyFilter();
                }

                async applyFilter() {
                  let self = this;
                  const newItems = await gudhub.util.getFilteredItems(this.items, filters.filters_list,
                      $scope.ghFieldData.data_model.app_id,
                      $scope.ghAppId,
                      $scope.ghItemId,
                      $scope.ghFieldData.data_model.field_groupe,
                      $scope.ghFieldData.data_model.search,
                      filters.search);

                  self.filtered = newItems;
                  self.sortItemsByField(self.getSortByField().id);
                    //-- Render values inside gh-element
                  $scope.$digest();
                }

                getItemAtIndex(index) {
                  return this.filtered[index];
                }

                getLength() {
                  return this.filtered.length;
                }

                getItems() {
                  return this.filtered;
                }

                sortItemsByField(fieldId, isUserIneracted) {
                  if (this.sortByField.id == fieldId) {
                    if (isUserIneracted) {
                      this.filtered.reverse();
                      let sortBy = this.getSortByField();
                      sortBy.descending = !sortBy.descending;
                    } else {
                      this.filtered = $filter('orderSort')(this.getItems(), this.getSortByField());
                    }
                  } else {
                    this.setSortByField({
                      id: fieldId,
                      descending: true
                    });
                    this.filtered = $filter('orderSort')(this.getItems(), this.getSortByField());
                  }
                }

                getSortByField() {
                  return this.sortByField;
                }
  
                setSortByField(obj) {
                  return this.sortByField = obj;
                }
              }

              if ($scope.ghFieldData.data_model.replace_items) {
                $scope.itemsList = new Items();
                const newItems = await gudhub.util.getFilteredItems($scope.ghFieldData.data_model.replace_items, [],
                                                       $scope.ghFieldData.data_model.app_id, 
                                                              $scope.ghAppId,
                                                             $scope.ghItemId,
                                                          $scope.ghFieldData.data_model.field_groupe, 
                                                             $scope.ghFieldData.data_model.search, 
                                                       '');
                  $scope.itemsList = new Items(newItems);
              } else if ($scope.appId) {
                $scope.itemsList = new Items();
              }


              // -------------------------------- GET FIELD LIST ------------------------------------------
              PipeService.on('gh_models_get gh_models_update', address, function modelsPipe(event, fieldList){
                PipeService.destroy('gh_models_get', address, modelsPipe);
                $scope.fieldsToView = gudhub.util.mergeFieldLists($scope.ghFieldData.data_model.table_settings.columns_to_view, fieldList);
                $scope.itemsList.sortItemsByField($scope.itemsList.getSortByField().id || $scope.fieldsToView[0].field_id);
                $scope.$apply();
              }, $scope).emit('gh_models_get', {}, address);


              // Set class to sortable column
              $scope.columnClass = function(fieldId) {
                let sortByField = $scope.itemsList.getSortByField();
                return fieldId == sortByField.id ? ' sort_' + (sortByField.descending ? 'desc' : 'asc') : null;
              };

              // Set info for selected item
              $scope.isSelected = function(item) {
                if (!item) return;
                return gudhub.util.isItemSelected($scope.appId, item.item_id);
              };

              $scope.isAllSelected = function() {
                return $scope.itemsList.getItems().every(i => gudhub.util.isItemSelected($scope.appId, i.item_id));
              };

              $scope.selectedItems = [];
              // Set\delete selected item to selction itels array
              $scope.selectItem = async function(event, item) {
                if($scope.ghFieldData.data_model.table_settings.selected_item == '1'){
                  event.preventDefault();
                  event.stopPropagation();
                  const isItemSelected = $scope.isSelected(item);
                  if($scope.selectedItems.includes(item.item_id) && isItemSelected){
                    $scope.selectedItems = $scope.selectedItems.filter(itemId => itemId != item.item_id);
                  } else {
                    $scope.selectedItems.push(item.item_id);
                  }
                  await gudhub.util.selectItems($scope.appId, [item]);
                  $scope.$emit('select-table-item', $scope.selectedItems);
                  $scope.$digest();
                }
              };

              let lastItemsCount, lastHeight;
              $scope.getTableHeightStyle = function() {
                if (lastItemsCount == $scope.itemsList.getItems().length) return lastHeight;
                lastItemsCount = $scope.itemsList.getItems().length;
                setTimeout(() => {
                  $element.find('md-virtual-repeat-container').controller('mdVirtualRepeatContainer').updateSize();
                }, 0);
                lastHeight = $scope.itemsList.getItems().length ? (Math.max($scope.ghFieldData.data_model.table_settings.table_height, 5) > $scope.itemsList.getItems().length  ? $scope.itemsList.getItems().length : $scope.ghFieldData.data_model.table_settings.table_height || 5) * 64 + 42 + 'px' : 'initial';
                return lastHeight;
              }


              $scope.selectAllFilteredItems = function($event) {
                $scope.activeCheckBtn = !$scope.activeCheckBtn;
                if($scope.activeCheckBtn){
                  gudhub.util.clearSelectedItems($scope.appId);
                }
                $scope.itemsList.getItems().forEach(i => {
                  $scope.selectItem($event, i);
                });
              };

              $scope.field_val = function(item, field_id) {
                if (!item || !field_id) return;
                let field = item.fields.find((f) => f.field_id == field_id);
                return field && field.field_value || '';
              };

              $scope.virtualRepeatId = $scope.$id;
              
            }],

            link: function(scope, element, attrs) {
                var template = '';
                scope.elementSrc = scope.$parent.elemSrc === "form" ? "document": scope.$parent.elemSrc;
                
                switch (scope.ghMode) {
                    case 'static':
                        template =
                            '<table>' +
                            '   <thead>' +
                            '       <th ng-if="ghFieldData.settings.hide_id" width="34px">ID</th>' +
                            '       <th ng-repeat="field in fieldsToView" width="{{field.width}}">' +
                            '           <span>{{field.field_name}}</span>' +
                            '       </th>' +
                            '   </thead>' +
                            '   <tr ng-repeat="item in itemsList.getItems() | limitTo:500">' +
                            '       <td ng-if="ghFieldData.settings.hide_id" width="34px">{{::$index + 1}}</td>' +
                            '       <td ng-repeat="column in fieldsToView" width="{{column.width}}" gh-element app-id="{{::appId}}" item-id="{{item.item_id}}" field-id="{{column.field_id}}" value="field_val(item, column.field_id)" elem-src="{{elementSrc}}"></td>' +
                            // I dont remember why i created "gh-td" directive but fo some reason it doesnt render calculated values so I commented the directive and turned everything back
                            //'<td width="{{column.width}}" ng-repeat="column in fieldsToView"><gh-td app-id="{{::appId}}" item-id="item.item_id" item="item" field-id="{{column.field_id}}" elem-src="{{elementSrc}}"></td>' +
                            '   </tr>' +
                            /*  Show then no matching items this criteria*/
                            '   <tr class="no-items" ng-if="items.length == 0">' +
                            '       <td><p>No items matching this criteria</p></td>' +
                            '   </tr>' +
                            '</table>';
                        break;

                    case 'dynamic':
                    default:
                        template =
                            // '<div class="gh-table-container" style="height:{{ itemsList.getItems().length ? (Math.max(ghFieldData.data_model.table_settings.table_height, 5) > itemsList.getItems().length  ? itemsList.getItems().length : ghFieldData.data_model.table_settings.table_height || 5) * 64 + 42 +\'px\' : \'initial\' }}">' +
                            '<div class="gh-table-container" style="height: {{getTableHeightStyle()}}">'+

                            '   <div class="repeated-item header" style="display: flex;" ng-show="app.items_list.length != 0">' +

                            '       <div ng-class="{\'noActiveCheckBtn\' : !activeCheckBtn}" class="gh-table-check"  {scope.isAllSelected() ? "gh-icon="checked 0893d2 16px normal" : " " } ng-click="selectAllFilteredItems($event)"></div>' +

                            '       <div style="cursor: pointer" ng-click="itemsList.sortItemsByField(field.field_id, true)" class="{{field.field_id != itemsList.getSortByField().id ? \'\' : \'active-sorting\'}}" ng-style="{width: field.width, minWidth: field.width}" ng-repeat="field in fieldsToView track by $index">' +
                            '           <span unselectable="on" onselectstart="return false;">{{field.field_name}}</span>' +
                            '           <div class="table_sort_icon {{columnClass(field.field_id)}}"></div>' +
                            '       </div>' +
                            '   </div>' +
                            '   <div class="no-items" ng-if="itemsList.getItems().length == 0">' +
                            '       <div class="icon" gh-icon="alert dfdfdf 56px normal"></div>'+
                            '       <div><p>No items matching this criteria</p></div>' +
                            '   </div>' +
                            '   <md-virtual-repeat-container class="flex-1" id="vertical-container-{{virtualRepeatId}}">' +
                            '       <div table-cell-click-handler ng-click="callback({item: item, app_id: appId})" class="repeated-item" md-on-demand="true" md-virtual-repeat="item in itemsList">' + // ng-repeat="item in itemList track by item.item_id"
                            '           <div class="row-count">' +
                                            // Add checkbox
                                            ( !!scope.ghFieldData.data_model.table_settings.selected_item ? '<span class="{{isSelected(item) ? \' selected\' : \'\'}}" gh-icon="checked 0893d2 16px normal" ng-click="selectItem($event, item)"></span>' : '')+
                            '              <p>{{$index+1}}</p>'+
                            '           </div>' +
                            '           <div ng-if="item.item_id" ng-repeat="field_model in fieldsToView" gh-element app-id="{{appId}}" item-id="{{item.item_id}}" field-id="{{field_model.field_id}}" ng-style="{width: field_model.width, minWidth: field_model.width}" elem-src="table"></div>'+
                            '           <div ng-if="!item.item_id" ng-repeat="field_model in fieldsToView" gh-element app-id="{{appId}}" field-id="{{field_model.field_id}}" value="field_val(item, field_model.field_id)" ng-style="{width: field_model.width, minWidth: field_model.width}" elem-src="table"></div>'+
                            '       </div>' +
                            '   </md-virtual-repeat-container>' +
                            '</div>';
                        break;
                }

                /* Append to DOM*/
                var el = angular.element(template);
                element.append($compile(el)(scope));

            }
        };
    }])




    /*===============================================================================================================*/
    /*=============================================    TD-RENDER     ================================================*/
    /*===============================================================================================================*/
    // directive to check click on item
    .directive('tableCellClickHandler', ['GHConstructor', 'Message', '$location', '$ocLazyLoad', function(GHConstructor, Message, $location, $ocLazyLoad) {
      return {
        restrict: 'A',
        link: function(scope, elem, attrs) {

          if (scope.ghFieldData.data_model.table_settings.action) {
            switch(scope.ghFieldData.data_model.table_settings.action){
              case 'open_item':
                elem.on('click', function(event) {
                  var element = event.target;
    
                  var wasClick = false;
                  var fieldModel = {};
    
                  while (element != elem[0]) {
    
                    fieldModel = angular.element(element).scope().field_model;
    
                    if(fieldModel && fieldModel.settings && fieldModel.settings.editable){
                      wasClick = true;
                      return;
                    } else {
                      element = element.parentNode;
                    }
                  }
    
                  if(!wasClick && scope.ghFieldData.data_model.table_settings.action){
                    $location.path('act/open_item/' + scope.appId + '/' + scope.ghFieldData.data_model.table_settings.view_id + '/' + scope.item.item_id);
                  }
    
                });
              break;
              case 'send_message':
                elem.on('click', function(event) {

                  var message = new Message({
                    app_id: scope.ghFieldData.data_model.send_message.app_id,
                    field_id: scope.ghFieldData.data_model.send_message.field_id
                  }, scope);

                  message.emit('send_message', {
                    to:{
                      app_id: scope.ghFieldData.data_model.send_message.app_id,
                      field_id: scope.ghFieldData.data_model.send_message.field_id
                    },
                    value: scope.item.item_id,
                  });
                  

                });
              break;
            }
 
          }
        }
      };
  }])

  // I Dont Remember why i created this directive but for some rison this directive doesnt render value for calculator
  .directive('ghTd', [function() {
    return {
          restrict: 'E',
          scope: {
              itemId: '@',
              appId: '@',
              elemSrc:'@',
              fieldId:'@',
              item: '='
          },

          
          controller: [ '$scope', '$element', '$rootScope', function($scope, $element, $rootScope) {
            function get_value(item, field_id) {
              if (!item || !field_id) return;
              let field = item.fields.find((f) => f.field_id == field_id);
              return field && field.field_value || '';
            };

            $scope.fieldVal = get_value( $scope.item, $scope.fieldId)
          }],
          

          template: '<gh-element width="{{width}}" app-id="{{appId}}" field-id="{{fieldId}}" value="fieldVal" elem-src="elemSrc"/>',
        }
    }]);
